// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook, createStore } from '@atlassian/react-sweet-state';
import { bannerDismissalStateActions } from './bannerDismissalStateActions.tsx';
import type { State } from './StateUserDismiss.types.tsx';

const initialState: State = {
	isLoading: false,
	isSuccess: false,
	error: null,
};

const store = createStore({
	actions: bannerDismissalStateActions,
	initialState,
	name: 'annoucement-banner-user-dismiss',
});

export const useUserDismiss = createHook(store);
export const useUserDismissActions = createHook(store, {
	selector: null,
});
